import Portfolio from './portfolio';

function App() {
  return (
    <Portfolio />
  );
}

export default App;